// Task lifetime is independent of the short microphone/speech lease.
export async function waitForAssistTask({ isCurrent, readStatus, sleep = ms => new Promise(resolve => setTimeout(resolve, ms)), attempts = 240 }) {
  for (let attempt = 0; attempt < attempts && isCurrent(); attempt++) {
    await sleep(1000);
    if (!isCurrent()) return null;
    const progress = await readStatus();
    if (!isCurrent()) return null;
    if (['waiting_user', 'complete', 'failed', 'cancelled'].includes(progress.status)) return progress;
  }
  if (!isCurrent()) return null;
  throw new Error('Task result monitoring timed out; completion is not confirmed');
}
